import PolicyPDF from "../components/PolicyPDF";
import "../css/policy.css";

const sections = [
  {
    title: "1. About These Terms",
    paragraphs: [
      "These Terms & Conditions govern the use of the IGC Print Press website and the purchase of printing, design, packaging, and related services from IGC Print Press.",
      "By submitting a quote request, approving artwork, making a payment, or otherwise engaging our services, you agree to these terms.",
    ],
  },
  {
    title: "2. Our Services",
    paragraphs: [
      "IGC Print Press provides commercial and creative printing services, including printed materials, branding materials, packaging, promotional materials, and related production services.",
      "The exact specifications, quantities, materials, finishing options, timelines, and prices for an order will depend on the agreed quotation.",
    ],
  },
  {
    title: "3. Quotes and Pricing",
    paragraphs: [
      "Quotes are based on the information supplied by the customer, including quantity, dimensions, materials, finishing, artwork, and other requirements.",
      "A quotation may need to be revised where the customer's requirements change or where additional work or materials become necessary.",
    ],
  },
  {
    title: "4. Artwork and Customer Responsibility",
    paragraphs: [
      "Customers are responsible for ensuring that artwork, logos, photographs, text, trademarks, and other materials supplied to IGC Print Press are accurate and authorised for use.",
      "Customers should carefully review spelling, dimensions, colours, contact information, and other details before approving artwork for production.",
    ],
  },
  {
    title: "5. Artwork Approval",
    paragraphs: [
      "Where a customer approves artwork or a proof for production, responsibility for errors that were visible in the approved artwork rests with the customer.",
      "IGC Print Press may request confirmation before production begins where clarification is required.",
    ],
  },
  {
    title: "6. Payment",
    paragraphs: [
      "Payment requirements will be communicated as part of the quotation or order confirmation.",
      "Production may not begin until the required deposit or payment has been received and any necessary artwork approval has been completed.",
    ],
  },
  {
    title: "7. Production Timelines",
    paragraphs: [
      "Production timelines depend on the nature and quantity of the order, material availability, artwork readiness, and other production requirements.",
      "Delays caused by incomplete information, late artwork approval, changes requested by the customer, or circumstances outside our reasonable control may affect the agreed timeline.",
    ],
  },
  {
    title: "8. Changes and Cancellations",
    paragraphs: [
      "Requests to change or cancel an order should be made as early as possible. Once production has started, changes or cancellations may not be possible or may result in additional costs.",
    ],
  },
  {
    title: "9. Finished Products",
    paragraphs: [
      "Printed materials may have minor variations in colour, cutting, finishing, or alignment due to the nature of commercial printing and production processes.",
      "Where a production issue occurs, customers should contact IGC Print Press promptly so that the matter can be reviewed.",
    ],
  },
  {
    title: "10. Intellectual Property",
    paragraphs: [
      "Customers retain responsibility for intellectual property they supply to us. By providing artwork or other materials for production, the customer confirms that they have the necessary rights or permissions to use those materials.",
    ],
  },
  {
    title: "11. Limitation of Responsibility",
    paragraphs: [
      "IGC Print Press will make reasonable efforts to deliver services according to the agreed specifications. Our responsibility is limited to the services and products covered by the relevant order and quotation.",
    ],
  },
  {
    title: "12. Contact",
    paragraphs: [
      "For questions regarding these Terms & Conditions or an existing order, contact IGC Print Press on +234 803 773 8028.",
    ],
  },
];

export default function Terms() {
  return (
    <div className="policy-page">
      <div className="wrap">
        <div className="policy-hero">
          <span className="hero-tag">
            <span className="pulse" />
            IGC PRINT PRESS
          </span>

          <h1 className="policy-title">
            Terms & Conditions
          </h1>

          <p className="policy-intro">
            These terms explain the conditions that apply when you request,
            approve, pay for, or receive printing and related services from
            IGC Print Press.
          </p>

          <span className="policy-updated">
            Last updated: September 2026
          </span>
        </div>

        <PolicyPDF
          title="Terms & Conditions"
          filename="IGC-Print-Press-Terms-and-Conditions.pdf"
          sections={sections}
        >
          <div className="policy-content">
            {sections.map((section) => (
              <section key={section.title}>
                <h2>{section.title}</h2>

                {section.paragraphs?.map((paragraph) => (
                  <p key={paragraph}>{paragraph}</p>
                ))}
              </section>
            ))}
          </div>
        </PolicyPDF>
      </div>
    </div>
  );
}